import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  getPolicyByEnrollmentPeriodId,
  triggerAlliedConfirmationLetter,
  triggerAlliedWelcomeLetter,
} from 'api/operations/policyService';
import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import ModalDelegate from 'store/general/modalDelegate';
import { File } from 'types/policyService';

interface DomainParams {
  enrollmentPeriodId: string;
}

export class WelcomeKitPageStore {
  private _domainParams: DomainParams;
  private _files: File[] = [];
  private _isLoading = false;
  public welcomeLetterModalDelegate = new ModalDelegate();
  public confirmationLetterModalDelegate = new ModalDelegate();

  public get files(): File[] {
    return this._files;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public setLoading(status: boolean): void {
    this._isLoading = status;
  }

  public async getInitialData(): Promise<void> {
    this.setLoading(true);
    const policy = await getPolicyByEnrollmentPeriodId(this._domainParams.enrollmentPeriodId);
    runInAction(() => {
      this._files = policy.filesFromDocx;
      this.setLoading(false);
    });
  }

  public async triggerAlliedWelcomeLetter(): Promise<void> {
    this.welcomeLetterModalDelegate.setIsLoading(true);
    await triggerAlliedWelcomeLetter(this._domainParams.enrollmentPeriodId);

    runInAction(() => {
      this.welcomeLetterModalDelegate.close();
      this.welcomeLetterModalDelegate.setIsLoading(false);
      toastManager.addToast('The welcome email has been sent successfully', ToastColorTypes.SUCCESS);
    });
  }

  public async triggerAlliedConfirmationLetter(): Promise<void> {
    this.confirmationLetterModalDelegate.setIsLoading(true);
    await triggerAlliedConfirmationLetter(this._domainParams.enrollmentPeriodId);

    runInAction(() => {
      this.confirmationLetterModalDelegate.close();
      this.confirmationLetterModalDelegate.setIsLoading(false);
      toastManager.addToast('The confirmation email has been sent successfully', ToastColorTypes.SUCCESS);
    });
  }

  constructor(domainParams: DomainParams) {
    makeAutoObservable(this, {}, { autoBind: true });
    this._domainParams = domainParams;
  }
}

const WelcomeKitPageStoreContext = createContext(new WelcomeKitPageStore({} as DomainParams));

export const useWelcomeKitPageStore = (): WelcomeKitPageStore => {
  return useContext(WelcomeKitPageStoreContext);
};

export { WelcomeKitPageStoreContext };
